import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import {
  CaretDown,
  CheckCircle,
  UserPlus,
} from "@phosphor-icons/react";


export default function CommercialScopeFilter({
  value,
  onChange,
  options = [],
  ariaLabel = "Filtrer par commercial",
  testId = "commercial-scope-filter",
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const normalizedValue = String(value || "");
  const normalizedOptions = Array.isArray(options)
    ? options.filter((option) => option?.value !== undefined)
    : [];
  const selected =
    normalizedOptions.find(
      (option) => String(option.value) === normalizedValue
    )
    || normalizedOptions[0]
    || { value: "", label: "Tous les commerciaux" };

  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    const handleOutside = (event) => {
      if (
        wrapperRef.current
        && !wrapperRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("mousedown", handleOutside);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleOutside);
    };
  }, [open]);

  return (
    <div
      ref={wrapperRef}
      className="acta-commercial-filter relative min-w-0"
      data-testid={testId}
    >
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        className={`acta-dashboard-filter-trigger acta-commercial-filter-trigger ${
          open ? "is-open" : ""
        }`}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={ariaLabel}
      >
        <span
          className="acta-dashboard-filter-icon"
          aria-hidden="true"
        >
          <UserPlus
            size={18}
            weight="duotone"
          />
        </span>

        <span className="min-w-0 flex-1 truncate text-left">
          {selected.label}
        </span>

        <CaretDown
          size={17}
          weight="bold"
          className={`acta-dashboard-filter-caret ${
            open ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        />
      </button>

      {open && (
        <div
          className="acta-commercial-filter-panel"
          role="listbox"
          aria-label={ariaLabel}
          data-testid={`${testId}-panel`}
        >
          {normalizedOptions.map((option) => {
            const optionValue = String(option.value);
            const active = optionValue === normalizedValue;

            return (
              <button
                key={option.key || optionValue}
                type="button"
                role="option"
                aria-selected={active}
                className={`acta-commercial-filter-option ${
                  active ? "is-active" : ""
                }`}
                onClick={() => {
                  onChange?.(option.value);
                  setOpen(false);
                }}
              >
                <span
                  className="acta-commercial-filter-option-icon"
                  aria-hidden="true"
                >
                  <UserPlus
                    size={18}
                    weight="duotone"
                  />
                </span>

                <span className="min-w-0 flex-1 truncate">
                  {option.label}
                </span>

                <span
                  className="acta-commercial-filter-check"
                  aria-hidden="true"
                >
                  {active && (
                    <CheckCircle
                      size={19}
                      weight="fill"
                    />
                  )}
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
